var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.25C12.4142 0.25 12.75 0.585786 12.75 1V4.5177C16.3039 4.86964 19.1304 7.69606 19.4823 11.25H23C23.4142 11.25 23.75 11.5858 23.75 12C23.75 12.4142 23.4142 12.75 23 12.75H19.4823C19.1304 16.3039 16.3039 19.1304 12.75 19.4823V23C12.75 23.4142 12.4142 23.75 12 23.75C11.5858 23.75 11.25 23.4142 11.25 23V19.4823C7.69606 19.1304 4.86964 16.3039 4.5177 12.75H1C0.585786 12.75 0.25 12.4142 0.25 12C0.25 11.5858 0.585786 11.25 1 11.25H4.51773C4.71021 9.30769 5.64215 7.58232 7.02615 6.36077C7.07046 6.32167 7.11809 6.28874 7.16799 6.26194C8.29378 5.31295 9.70274 4.68924 11.25 4.53567V1C11.25 0.585786 11.5858 0.25 12 0.25ZM11.9999 18.0014C15.3144 18.0014 18.0013 15.3145 18.0013 12C18.0013 8.68556 15.3144 5.99866 11.9999 5.99866C8.68543 5.99866 5.99854 8.68556 5.99854 12C5.99854 15.3145 8.68543 18.0014 11.9999 18.0014ZM13.8847 12C13.8847 13.0408 13.0409 13.8846 12.0001 13.8846C10.9592 13.8846 10.1155 13.0408 10.1155 12C10.1155 10.9591 10.9592 10.1154 12.0001 10.1154C13.0409 10.1154 13.8847 10.9591 13.8847 12ZM15.3847 12C15.3847 13.8692 13.8694 15.3846 12.0001 15.3846C10.1308 15.3846 8.61548 13.8692 8.61548 12C8.61548 10.1307 10.1308 8.61536 12.0001 8.61536C13.8694 8.61536 15.3847 10.1307 15.3847 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackWhite);
export default __webpack_public_path__ + "static/media/TrackWhite.20a0c5e52bdf2ba31e0862cf787f4346.svg";
export { ForwardRef as ReactComponent };